module.exports = require("./ee.d.ts");